import React from 'react';

import { ArrowDown } from '../Icons';

import {
  Accordion as AccordionStyled,
  AccordionHeader,
  AccordionContent,
} from './AccordionStyles';
import { ToggleTimeWindowsProps } from 'components/TimeWindow/TimeWindows';
import { ContainerOutline } from 'components/TimeWindow';

type Props = {
  children: React.ReactNode;
  headerElements: React.ReactNode;
  index: string;
  onClick: (props: ToggleTimeWindowsProps) => void;
  isOpened: boolean;
  title?: string;
  color?: string;
  size?: string;
  isNew?: boolean;
};

export const CustomAccordion: React.FC<Props> = ({
  children,
  onClick,
  title,
  size = '10px',
  color = '#BCBCBC',
  headerElements,
  isOpened = false,
  isNew = false,
  index,
}) => {
  if (isOpened) {
    return (
      <ContainerOutline isNew={isNew}>
        <AccordionStyled isOpen={isOpened}>
          <AccordionHeader>
            {headerElements}
            <ArrowDown
              transform={isOpened ? '' : 'rotate(-90deg)'}
              size={size}
              fill={color}
              onClick={() => {
                onClick({ index });
              }}
            />
          </AccordionHeader>
          <AccordionContent>{children}</AccordionContent>
        </AccordionStyled>
      </ContainerOutline>
    );
  }

  return (
    <ContainerOutline isNew={isNew}>
      <AccordionStyled isOpen={isOpened}>
        <AccordionHeader>
          {headerElements}
          <ArrowDown
            transform={isOpened ? '' : 'rotate(-90deg)'}
            size={size}
            fill={color}
            onClick={() => {
              onClick({ index });
            }}
          />
        </AccordionHeader>
      </AccordionStyled>
    </ContainerOutline>
  );
};
